export type TopActivityLogsTypes = {
  id: number;
  ipAddress: string;
  userAgent: string;
  createdAt: string;
  updatedAt: string;
  actionName: string;
  modelId: number;
  modelName: string;
  modelData?: {
    title: string;
  };
  user: {
    id: number;
    email: string;
    name: string;
    avatar?: any;
    bgAvatar: string;
  };
};

export type GaSummariesParamsTypes = {
  from: string;
  to: string;
  metrics?: string[];
  dimensions?: string[];
  groupBy?: string;
};

export type GaVisitorParamsTypes = {
  from: string;
  to: string;
};

export type GaSummariesTypes = {
  date?: string;
  sessions?: number;
  activeUsers?: number;
  year?: number;
  month?: 2;
  yearMonth?: string;
};

export type GaPagesTrackingTypes = {
  bounceRate: number;
  engagedSessions: number;
  engagementRate: number;
  itemViews: number;
  newUsers: number;
  pageLocation: string;
  screenPageViews: number;
  screenPageViewsPerSession: number;
};

export type GaUsersTracking = {
  newUsers: number;
  activeUsers: number;
  region: string;
  country: string;
  deviceCategory: string;
  browser: string;
};

export type GaVisitorTracking = {
  sessions: number,
  activeUsers: number,
  newUsers: number,
  totalUsers: number,
  date: string
};

export type QuickActionSummaryType = {
  status: number;
  count: number;
};

export type QuickActionSummaryParams = {
  prefix: 'page' | 'news';
};

export type GenderType = 'male' | 'female' | 'all';

export type DateParams = {
  from: string;
  to: string;
  ageFrom?: number;
  ageTo?: number;
  gender?: GenderType;
};

export type GaLocationsTrackingTypes = {
  sessions: number;
  cityId: string;
};

export type GaPageGroupBy = '1days' | '7days' | '30days';

export type GaPageTrackingParamsTypes = {
  groupBy: GaPageGroupBy
};
export type GaPageTrackingTypes = {
  pageLocation: string,
  pageTitle: string,
  current: number,
  previous: number,
  ratio: number
};

export type DeviceList = {
  deviceCategory: string;
  sessions: number;
};

export type SurveyChartResponseDataTypes = {
  kiosk?: string;
  kioskGroup?: string;
  heartRisk?: string;
  kidneyRisk?: string;
  rowsCount: number;
  year?: number;
  month?: number;
  day?: number;
};

export type CounterbyMonthDataTypes = {
  yearMonth: string
  total: number
};

export type SummariesDataRequest = {
  from?: string;
  to?: string;
  type?: number;
  kioskGroupIds?: string;
  page?: number;
  limit?: number;
};

export type SummariesDataTypes = {
  type: number
  total: number
};

export type YearDataTypes = {
  type: number
  year: number
  total: number
};

export interface SummariesDataRequestExtend extends SummariesDataRequest {
  ageFrom?: number;
  ageTo?: number;
  'setupAt[gte][0]'?: string;
  'setupAt[lte][0]'?: string;
}

export type CounterbyAccountDataTypes = {
  account: number
  total: number
};

export type KioskByStatusDataTypes = {
  id: number;
  code: string;
  name: string;
  type: number;
  isWorking: boolean;
};

export type KioskAnalyticDataTypes = {
  gender: {
    male: number;
    female: number;
  },
  age: {
    less40: number;
    between40And50: number;
    between50And69: number;
    over70: number;
  };
  htl: {
    yes: number;
    no: number;
  };
};

export type YesNoUnknowTypes = {
  yes: number;
  no: number;
  unknow: number;
};

export type KioskAnalyticHeartRiskDataTypes = {
  tha: {
    answers: YesNoUnknowTypes,
    ranges: {
      between100And119: number
      between120And139: number
      between140And159: number
      between160And179: number
      less100: number
      over180: number
    }
  },
  rlmm: {
    answers: YesNoUnknowTypes,
    ranges: {
      between3And39: number
      between4And49: number
      between5And59: number
      between60And69: number
      less3: number
      over7: number
    }
  },
  dtd: {
    dtd: number
    dtdOver10Years: number
    loetchan: number
    momat: number
    tieudam: number
  };
};

export type KioskAnalyticAtherosclerosisDataTypes = {
  dotquyThieumau: YesNoUnknowTypes
  nhoimaucotim: YesNoUnknowTypes
  datstent: YesNoUnknowTypes
  dauthatnguc: YesNoUnknowTypes
  phinhtachdongmach: YesNoUnknowTypes
};

export type KioskAnnalyticKidneyRiskDataTypes = {
  thieumau: YesNoUnknowTypes
  suytim: YesNoUnknowTypes
  maungoaibien: YesNoUnknowTypes
  tieudam: YesNoUnknowTypes
  tha: YesNoUnknowTypes
  nmct: YesNoUnknowTypes
  dtd: YesNoUnknowTypes
  dotquyOrTIA: YesNoUnknowTypes
};

export type KioskKidneyRiskDataTypes = {
  cdk: string;
  total: number
};

export type KioskHeartsRiskDataTypes = {
  heartRiskCode: string;
  total: number
};

export type KioskHeartsRiskByMonthDataTypes = {
  heartRiskCode: string;
  total: number
  yearMonth: string
};

export type PercentageResult = {
  heartRiskCode: string;
  percentage: string;
};

export type MonthlyResult = {
  yearMonth: string;
  percentages: PercentageResult[];
};

export type YTNCByMonthDataTypes = {
  [groupName: string]: CounterbyMonthDataTypes[];
};

export type YTNCForPieDataTypes = {
  [name: string]: number;
};

export type KioskWarrantyTypes = {
  name: string;
  total: number;
};

export enum KioskGroupReportType {
  QR = 1,
  Kiosk = 2,
  HIS = 3,
}

export const KioskGroupReportTypeTrans = {
  [KioskGroupReportType.QR]: 'QR Code',
  [KioskGroupReportType.Kiosk]: 'Kiosk',
  [KioskGroupReportType.HIS]: 'HIS',
};

export type KioskGroupReport = {
  name: string;
  setupAt: string;
  cumulative: number;
  avgMonthly: number;
  heartRiskHighAndVeryHigh: number;
  heartRisk: number;
  type: KioskGroupReportType[]
};

export type KioskGroupReportGetAll = {
  data: KioskGroupReport
};

export type YTNCDataTypes = {
  zeroYTNC: number;
  oneYTNC: number;
  twoYTNC: number;
  threeYTNC: number;
};

export enum HeartRiskEnum {
  missingKidneyRisk = 'missingKidneyRisk',
  missingHeartRisk = 'missingHeartRisk',
  na = 'na',
  empty = 'empty',
  unknow = 'unknow',
  low = 'low',
  medium = 'medium',
  high = 'high',
  veryHigh = 'veryHigh',
  highAndVeryHigh = 'highAndVeryHigh',
  lowAndMedium = 'lowAndMedium',
  matrixAndLessAge = 'matrixAndLessAge',
}

export type YTNCByHeartRiskItem = {
  heartRiskCode: HeartRiskEnum;
  total: number
};

export type YTNCByHeartRisk = {
  oneYTNC: YTNCByHeartRiskItem[];
  twoYTNC: YTNCByHeartRiskItem[];
  threeYTNC: YTNCByHeartRiskItem[];
};

export type YTNCForOneByHeartRisk = {
  ytncDTD: YTNCByHeartRiskItem[];
  ytncHTL: YTNCByHeartRiskItem[];
  ytncRLLP: YTNCByHeartRiskItem[];
  ytncTHA: YTNCByHeartRiskItem[];
};

export enum KidneyRiskCode {
  noneCDK = 'noneCDK',
  hasCDK = 'hasCDK',
  inDangerOfCDK = 'inDangerOfCDK',
}

export type AgeByKidneyRisk = {
  less40: number;
  between40And50: number;
  between50And69: number;
  over70: number;
  kidneyRiskCode: KidneyRiskCode
};

export type AtherosclerosisByKidneyRisk = {
  dotquyThieumau: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  nhoimaucotim: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  datstent: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  dauthatnguc: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  phinhtachdongmach: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
};

export type YTNCForOneByKidneyRisk = {
  ytncDTD: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  ytncTHA: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
  ytncRLLP: {
    kidneyRiskCode: KidneyRiskCode
    total: number
  }[],
};

export type CounterbyQuarterDataTypes = {
  quarter: string;
  total: number;
  year: string;
};
